import { notifyLocaleChanged } from '../i18n/uiText';
import { sortLanguagesByDisplayOrder } from './sortLanguages';

const API_BASE = import.meta.env.VITE_API_URL || 'https://verbum-api-production.up.railway.app/api';
export const DEFAULT_UI_LANGUAGE = 'en';
export const DEFAULT_TRANSLATION_BY_LANGUAGE = {
  en: 'kjv',
  ru: 'synodal',
};

let languagesCache = null;

export async function fetchLanguagesList() {
  if (languagesCache) return languagesCache;
  try {
    const response = await fetch(`${API_BASE}/languages`);
    if (!response.ok) return null;
    const data = await response.json();
    const raw = data.languages || null;
    languagesCache = raw ? sortLanguagesByDisplayOrder(raw) : null;
    return languagesCache;
  } catch {
    return null;
  }
}

export function getDefaultTranslationForLanguage(langCode) {
  const code = String(langCode || '').toLowerCase();
  return DEFAULT_TRANSLATION_BY_LANGUAGE[code] || DEFAULT_TRANSLATION_BY_LANGUAGE[DEFAULT_UI_LANGUAGE];
}

export function getStoredLanguageOrDefault() {
  if (typeof window === 'undefined') return DEFAULT_UI_LANGUAGE;
  return (localStorage.getItem('bibleLanguage') || DEFAULT_UI_LANGUAGE).toLowerCase();
}

export function getStoredTranslationOrDefault() {
  if (typeof window === 'undefined') return getDefaultTranslationForLanguage(DEFAULT_UI_LANGUAGE);
  const stored = localStorage.getItem('bibleTranslation');
  if (stored) return stored;
  return getDefaultTranslationForLanguage(getStoredLanguageOrDefault());
}

/** Язык интерфейса по id перевода (как в languages.json). */
export function getLanguageCodeForTranslationId(translationId, languages) {
  if (!translationId || !languages?.length) return null;
  const owner = languages.find(
    (lang) =>
      Array.isArray(lang.translations) &&
      lang.translations.some((t) => t.id === translationId)
  );
  return owner?.code ?? null;
}

/** Сохранить bibleLanguage по текущему переводу (чат, прямой заход по URL без шапки). */
export async function syncBibleLanguageFromTranslation(translationId) {
  if (!translationId || typeof window === 'undefined') return null;
  const langs = await fetchLanguagesList();
  const code = getLanguageCodeForTranslationId(translationId, langs);
  if (!code) return null;
  if (localStorage.getItem('bibleLanguage') !== code) {
    localStorage.setItem('bibleLanguage', code);
  }
  return code;
}

/** Восстановить язык и перевод с сервера (/api/auth/me). Сохраняет текущий перевод, если он ещё относится к этому языку. */
export async function applyPreferredLanguageFromProfile(langCode) {
  if (!langCode || typeof window === 'undefined') return;
  const code = String(langCode).toLowerCase();
  localStorage.setItem('bibleLanguage', code);
  notifyLocaleChanged();
  const langs = await fetchLanguagesList();
  const lang = langs?.find((l) => l.code === code);
  if (!lang?.defaultTranslation) return;
  const storedTr = localStorage.getItem('bibleTranslation');
  const stillValid =
    storedTr && Array.isArray(lang.translations) && lang.translations.some((t) => t.id === storedTr);
  if (!stillValid) {
    localStorage.setItem('bibleTranslation', lang.defaultTranslation);
  }
}
